export const DataTable = () => import("./DataTable.vue");
export const List = () => import("./List.vue");
export const Create = () => import("./Create.vue");
export const BulkCreate = () => import("./BulkCreate.vue");
export const Edit = () => import("./Edit.vue");
export const Show = () => import("./Show.vue");
export const StoreItems = () => import("./StoreItems.vue");
